import { render } from "./AnswerDialog.vue?vue&type=template&id=485b9a94&scoped=true"
import script from "./AnswerDialog.vue?vue&type=script&lang=js"
export * from "./AnswerDialog.vue?vue&type=script&lang=js"

import "./AnswerDialog.vue?vue&type=style&index=0&id=485b9a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485b9a94"]])

export default __exports__